import React from 'react';

import { HStack, Icon, Text, ToggleTip } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { urlBuilder } from '../../../Shared/urlBuilder';

export const EditAssumptionsBanner: React.FC = () => (
  <HStack
    css={{
      gap: 'space.100',
      alignItems: 'center',
      background: 'background.neutral',
      p: 'space.150',
      borderRadius: 'medium',
    }}
  >
    <Icon name="InfoCircle" size="xsmall" color="icon.weak" />
    <Text variant="text50" color="text.weak">
      For the most accurate guidance, confirm your{' '}
      <SambaAutoLink to={urlBuilder.appFinancialProfileEdit.absolute()}>financial profile</SambaAutoLink> and{' '}
      <SambaAutoLink to={urlBuilder.appExternalAccounts.absolute()}>link external accounts</SambaAutoLink>.
    </Text>
  </HStack>
);

export const EditAssumptionsToggleTip: React.FC = () => (
  <ToggleTip>
    <ToggleTip.Trigger iconName="InfoCircle" label="Recommendation information" />
    <ToggleTip.Content side="right" css={{ maxWidth: '300px' }}>
      Our recommendation is based on your financial profile and all connected accounts. For the most accurate
      recommendation, confirm your financial profile and link external accounts in your settings.
    </ToggleTip.Content>
  </ToggleTip>
);
